import RecipeExportPage from '@/components/pages/RecipeExportPage';
export default function ExportPage() {
  return <RecipeExportPage />;
}
